<label class="dropzone clearfix"
  (drop)="onDrop($event)"
  (dragenter)="onDragEnter()"
  (dragover)="onDragOver()"
  (dragleave)="onDragLeave()">

  <input type="file"
    data-tests-id="upload-file"
    id="selectFile"
    [disabled]="fileInternal"
    (change)="change($event)"
    #input>

  <span class="dropzone_empty main-text main-text_charcoal" *ngIf="!fileInternal">
    <svg [ngSwitch]="type" *ngIf="type !== 'back'" class="svg-icon dropzone__icon" width="50" height="65">
      <use *ngSwitchDefault xlink:href="#identification-icon"></use>
      <use *ngSwitchCase="'back'" xlink:href="#identification-back-icon"></use>
      <use *ngSwitchCase="'birth'" xlink:href="#birth-certificate"></use>
    </svg>
    <svg *ngIf="type == 'back'" class="svg-icon dropzone__icon" width="50" height="65">
      <use xlink:href="#identification-back-icon"></use>
    </svg>
    <ng-container i18n="uploading">Drop or select file</ng-container>
  </span>

  <span class="dropzone_pdf main-text main-text_charcoal" *ngIf="fileInternal?.type == 'application/pdf'">
    <svg class="svg-icon dropzone__icon" width="35" height="45">
      <use xlink:href="#pdf-icon"></use>
    </svg>
    {{ fileInternal.name }}
  </span>

  <span class="dropzone_image"
        *ngIf="fileInternal && fileInternal?.type !== 'application/pdf'">
    <img [src]="sanUrl()" [alt]="fileInternal?.name">
    <ng-container i18n="@@image">Image</ng-container>
  </span>
</label>

<bc-messages [element]="fakeInput"></bc-messages>

<button class="remove-file" (click)="remove()" *ngIf="fileInternal" tabindex="-1">
  <svg class="svg-icon" width="14" height="14">
    <use xlink:href="#close-icon"></use>
  </svg>
  <ng-container i18n="@@removeDocument">Remove document</ng-container>
</button>
